// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"NotFound_NotFound__AmwKj","NotFoundPara":"NotFound_NotFoundPara__3oCMN","ImgContainer":"NotFound_ImgContainer__3eTEn","ImgLink":"NotFound_ImgLink__1-jzY"};